
const CONTEXT_PARAM_NAME = "nc";
const PARAM_TYPE_OBJECT = 'object';
const PARAM_TYPE_PRIMITIVE = 'primitive';
class HistoryItem {
    constructor(url, params) {
        this.url = url;
        this.params = params;
    }       
}

class HistoryItemParam {
    constructor(name, type, value) {
        this.name = name;
        this.type = type;
        this.value = value;
    }
}

export default class NavigationContext {


    constructor(location, history) {
        this.history = [];
        this.location = location;
        this.browserHistory = history;
        this.callerHistoryItem = null;

        this.serialized = null;

        //const url = this.#getCurrentViewUrl();
        //this.history.push(new HistoryItem(url, []));
    }

    #getCurrentViewUrl(){
        return this.location?.pathname ? this.location?.pathname : null;
    }

    #encodeObject(obj) {
        return btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
    }

    #decodeObj(obj) {
        return JSON.parse(decodeURIComponent(escape(atob(obj))))
    }

    #serialize() {
        if (!this.browserHistory) {
            return null;
        }
        this.serialized = this.#encodeObject(this.history);
        return this.serialized;
    }

    addOrUpdateParam(paramName, paramValue) {
        if (!this.browserHistory) {
            return this;
        }
        const currentView = this.#getCurrentViewUrl();
        if (!currentView) {
            return this;
        }
        const params = this.history.find(item => item.url === currentView).params;
        const paramIndex = params.findIndex(p => p.name === paramName);
        if (paramIndex >= 0) {
            params.splice(paramIndex, 1);
        }
        if (typeof paramValue === "object") {
            params.push(new HistoryItemParam(paramName, PARAM_TYPE_OBJECT, this.#encodeObject(paramValue)));
        } else {
            params.push(new HistoryItemParam(paramName, PARAM_TYPE_PRIMITIVE, paramValue));
        }
        const searchParams = new URLSearchParams(this.location.search || ""); 
        searchParams.set(CONTEXT_PARAM_NAME, this.#serialize());
        this.browserHistory.replace(`?${searchParams.toString()}`);
        return this;        
    }

    getParam(paramName) {
        if (!this.browserHistory) {
            return null;
        }
        const currentView = this.#getCurrentViewUrl();
        if (this.history.length === 0) {
            return null;
        }
        const params = this.history.find(item => item.url === currentView).params;
        const param = params.find(p => p.name === paramName);
        if (param) {
            if (param.type === PARAM_TYPE_OBJECT) {
                return this.#decodeObj(param.value);
            } else if (param.type === PARAM_TYPE_PRIMITIVE) {
                return param.value;
            }

        } else {
            return null;
        }
    }

    getCallerParam(paramName) {
        if (!this.browserHistory) {
            return null;
        }
        if (this.callerHistoryItem) {
            const param = this.callerHistoryItem.params.find(p => p.name === paramName);
            if (param) {
                if (param.type === PARAM_TYPE_OBJECT) {
                    return this.#decodeObj(param.value);
                } else if (param.type === PARAM_TYPE_PRIMITIVE) {
                    return param.value;
                }
    
            } else {
                return null;
            }
        } else {
            return null;
        }
    }

    getAndRemoveCallerParam(paramName) {
        if (!this.browserHistory) {
            return null;
        }
        const result = this.getCallerParam(paramName);
        if (this.callerHistoryItem) {
            const params = this.callerHistoryItem.params;
            const paramIndex = params.findIndex(p => p.name === paramName);
            if (paramIndex >= 0) {
                params.splice(paramIndex, 1);
            }
        }
        return result;
    }

    parse() {
        if (!this.browserHistory) {
            return this;
        }
        const queryParams = new URLSearchParams(this.location?.search);
        const ctx = queryParams?.get(CONTEXT_PARAM_NAME);
        if (ctx) {
            try {
                this.history = this.#decodeObj(ctx);
            } catch(err) {
                this.history = [];
            }
            
        } else {
            this.history = [];
        }
        return this;        
    }

    registerView() {
        if (!this.browserHistory) {
            return this;
        }
        const currentView = this.#getCurrentViewUrl();
        if (currentView) {
            this.callerHistoryItem = this.history.length === 0 ? null : this.history[this.history.length - 1];
            const currenViewIndex = this.history.findIndex(item => item.url === currentView);
            if (currenViewIndex < 0) {
                this.history.push(new HistoryItem(currentView, []));
            } else {
                this.history.splice(currenViewIndex + 1);
            }           
            this.browserHistory.replace(`?${CONTEXT_PARAM_NAME}=${this.#serialize()}`);
        }
        return this;
    }

    #generateNavigationContextParamForForwardUrl() {
        return `${CONTEXT_PARAM_NAME}=${this.serialized}`;
    }

    addNavigationContextToUrl(baseUrl) {
        if (!this.browserHistory) {
            return baseUrl;
        }
        if (baseUrl.indexOf(CONTEXT_PARAM_NAME) < 0) {
            if (baseUrl.indexOf("?") > 0) {
                return baseUrl += '&' + this.#generateNavigationContextParamForForwardUrl();
            } else {
                return baseUrl += '?' + this.#generateNavigationContextParamForForwardUrl();
            }
        }
        return baseUrl;
    }

    generaterBackUrl() { 
        if (!this.browserHistory) {
            return null;
        }
        const currentView = this.#getCurrentViewUrl();
        const lastList = this.history.findLast(item => (currentView != item.url) && (item.url.includes('list') || item.url.includes('dashboard')));
        if (lastList) {
            const result = `/#${lastList.url}?${CONTEXT_PARAM_NAME}=${this.serialized}`;
            return result;
        }
        return null;
    }



    

    

}